import { render, staticRenderFns } from "./Litterature.vue?vue&type=template&id=46c4e90d&"
import script from "./Litterature.vue?vue&type=script&lang=js&"
export * from "./Litterature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports